export default "__VITE_ASSET__CbH8ssWJ__"